// extracted by mini-css-extract-plugin
export default {"newOffRampButton":"NewOffRampButton_newOffRampButton__YEbpT"};